<template>
    <card class="spaced typo" v-if="clearAllowed">

        <h2 class="text-white">
            {{ $t('xapi.management.clear-all.title') }}
        </h2>
        <p>
            {{ $t('xapi.management.clear-all.description') }}
        </p>

        <base-button type="primary mt-2" :loading="deleting" @click="clearAll">
            {{ $t('xapi.management.clear-all.button') }}
        </base-button>

        <div class="text-danger pt-2" v-if="errorMessage">
            {{ errorMessage }}
        </div>

        <portal to="modals">
            <modal-confirm v-model="modals.confirmClearAll">
                <p>{{ $t('xapi.management.clear-all.confirm') }}</p>
            </modal-confirm>
        </portal>

    </card>
</template>

<script>
    import ModalsController from '@trax/classes/ModalsController'

    export default {

        data() {
            return {
                modals: new ModalsController('confirmClearAll'),
                deleting: false,
                errorMessage: false
            }
        },

        created() {
            this.modals.watch(this, 'modals')
        },

        computed: {

            clearAllowed() {
                return this.$auth.hasPermission('owner.delete')
            }
        },

        methods: {

            clearAll() {
                this.errorMessage = false
                this.modals.open('confirmClearAll').then(resp => {
                    if (resp.confirmed) {
                        this.deleting = true
                        axios.post(
                            '/trax/api/front/xapi/ext/stores/' + this.$auth.owner.id + '/clear',
                        )
                        .then(response => {
                            this.deleting = false
                        })
                        .catch(error => {
                            this.deleting = false
                            if (error.response.status == 409) {
                                this.errorMessage = this.$t('xapi.management.clear-all.conflict')
                            } else {
                                this.errorMessage = this.$t('xapi.management.clear-all.error')
                                this.$auth.handleErrorVm(error, this)
                            }
                        });
                    }
                })
            }
        }
    }
</script>
